
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class InvoiceDetailedReportGrid extends Serenity.EntityGrid<InvoiceDetailedReportRow, any> {
        protected getColumnsKey() { return InvoiceDetailedReportColumns.columnsKey; }
        protected getDialogType() { return InvoiceDetailedReportDialog; }
        protected getIdProperty() { return InvoiceDetailedReportRow.idProperty; }
        protected getInsertPermission() { return InvoiceDetailedReportRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceDetailedReportRow.localTextPrefix; }
        protected getService() { return InvoiceDetailedReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: InvoiceDetailedReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}